import Image from "next/image";
import { STOCK_REBATE_CDN, STOCK_REBATE_TESLA_COIN } from "./constants";

/** 设计稿基准 375 × 352，所有尺寸按容器等比缩放 */
export default function SpaceScene() {
  return (
    <div className="relative mt-2 aspect-[375/352] w-full overflow-hidden" aria-hidden="true">
      {/* hero::after 大背景弧线 */}
      <div className="absolute bottom-[2.273%] right-[-29.333%] h-[51.136%] w-[112%] rotate-[-12deg] rounded-[50%] border border-white/[0.28]" />

      {/* space-scene::before 紫色光晕 */}
      <div className="absolute bottom-[0.568%] right-[-19.733%] z-0 h-[52.557%] w-[82.667%] rotate-[-12deg] rounded-full bg-[radial-gradient(circle,rgba(124,79,255,0.32),transparent_68%)] blur-[0.8vw]" />

      {/* orbit 三层椭圆轨道 */}
      <div className="absolute bottom-[7.67%] right-[-17.067%] box-border h-[27.841%] w-[87.467%] rotate-[-14deg] rounded-[50%] border border-white/[0.35]">
        <div className="absolute inset-x-[8.537%] inset-y-[13.265%] rounded-[50%] border border-white/[0.35]" />
        <div className="absolute inset-x-[17.683%] inset-y-[27.551%] rounded-[50%] border border-white/[0.35]" />
      </div>

      <Image
        src={`${STOCK_REBATE_CDN}/meteor-small.png`}
        width={110}
        height={110}
        alt=""
        className="absolute left-[10.667%] top-[-0.568%] z-[1] h-auto w-[29.333%] rotate-[23deg] opacity-[0.86]"
      />

      <Image
        src={`${STOCK_REBATE_CDN}/rocket.png`}
        width={148}
        height={85}
        unoptimized
        alt=""
        className="absolute left-[4.267%] top-[12.5%] z-[2] h-auto w-[39.467%] drop-shadow-[0_10px_12px_rgba(18,0,80,0.34)]"
      />

      <span className="absolute left-[3.2%] top-[40.341%] z-[3] flex aspect-square w-[21.867%] shrink-0 items-center justify-center rounded-full border-2 border-[rgba(249,225,138,0.75)] bg-[rgba(51,24,102,0.42)] shadow-[0_0_20px_rgba(249,225,138,0.16)]">
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img
          src={STOCK_REBATE_TESLA_COIN}
          width={58}
          height={58}
          alt=""
          className="block h-[70.732%] w-[70.732%] max-h-[70.732%] max-w-[70.732%] object-contain"
        />
      </span>

      <Image
        src={`${STOCK_REBATE_CDN}/hero-main.png`}
        width={660}
        height={660}
        priority
        alt=""
        className="pointer-events-none absolute left-[2.667%] top-[-13.636%] z-[4] h-auto w-[121.067%] max-w-none drop-shadow-[0_18px_22px_rgba(8,0,45,0.38)]"
      />
    </div>
  );
}
